import type { ReactNode } from "react";

interface Props {
  open: boolean;
  title?: ReactNode;
  body?: ReactNode;
  extra?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export function ConfirmModal({
  open,
  title,
  body,
  extra,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  danger,
  onConfirm,
  onCancel,
}: Props) {
  const titleNode: ReactNode = title ?? "Confirmer l'action";
  if (!open) return null;
  return (
    <div
      className="modal-overlay is-open"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="modal modal-sm">
        <div className="modal-title">{titleNode}</div>
        {body && <p className="modal-body-text">{body}</p>}
        {extra}
        <div className="modal-footer">
          <button type="button" className="btn-sm btn-ghost" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={"btn-sm " + (danger ? "btn-danger" : "btn-primary")}
            style={{ width: "auto", padding: "8px 20px" }}
            onClick={() => void onConfirm()}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
